import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Inside a Google onsite interview",
  "description": "",
  "published": "2012-05-15T00:00:00.000Z",
  "redirect_from": ["/blog/inside-a-google-onsite-interview/swizec/4352"],
  "categories": "Companies, Google, Interview, London, Question, Search Engines, Travel + Events",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Last Friday I found myself in Google's `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=51.5072222222,-0.1275&spn=0.1,0.1&q=51.5072222222,-0.1275%20(London)&t=h",
        "title": "London"
      }}>{`London`}</a>{` HQ, talking about cool problems with a bunch of engineers. The so called "onsite interviews".`}</p>
    <p><img parentName="p" {...{
        "src": "https://distilleryimage0.s3.amazonaws.com/c159a6949b5311e1a92a1231381b6f02_7.jpg",
        "alt": "Google's parlour",
        "title": "Google's parlour"
      }}></img></p>
    <p>{`The saga started a few months ago with `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/a-google-phone-interview/swizec/3813",
        "title": "A Google phone interview"
      }}>{`two phone interviews`}</a>{`.`}</p>
    <p>{`Then `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/google-sent-me-a-what-to-know-in-on-site-interviews-email-here-it-is/swizec/4251",
        "title": "Google sent me a “what to know in on-site interviews” email. Here it is."
      }}>{`Google sent me a "What to know in onsite interviews" email`}</a>{`.`}</p>
    <p>{`And here I was, completely unprepared, having the time of my life just chiling in the awesome parlour they have going at the reception desk (inside a very confusing building ... who puts a reception desk on the top floor anyway?)`}</p>
    <p><em parentName="p">{`A disclaimer: some say they had to sign NDA's and stuff. Nobody mentioned to me personally that any of this was a secret. And hey, `}<a parentName="em" {...{
          "href": "http://www.quora.com/How-many-people-who-take-the-Google-onsite-interviews-end-up-getting-the-job"
        }}>{`only ~25% of onsite candidates get hired`}</a>{`, there are 30,000 employees - that means 120,000 people have seen what happens.`}</em></p>
    <p><em parentName="p">{`It's not a secret.`}</em></p>
    <h2 {...{
      "id": "the-interviews"
    }}>{`The interviews`}</h2>
    <p>{`There I was, lounging in a comfy leather chair. Just when I was thinking `}<em parentName="p">{`"Fuck, I blew it. I knew I shouldn't have been 5 minutes late!"`}</em>{` my recruiter came in through the door and apologized - her office is across the street nowadays and it takes a while to get to the main building.`}</p>
    <p>{`Phew.`}</p>
    <p>{`She walked me through a series of doors, swiped her keycard a few times, quipped about the `}<em parentName="p">{`epic`}</em>{` naming scheme for the interview (meeting?) rooms. Named after cornerstone computers of history, most recently The Watson.`}</p>
    <p>{`I found myself in a small white room. Nothing more than a desk, a small whiteboard, a phone and a huge LCD screen. Hell, the holding room at the police station I was once taken to as a teen was bigger.`}</p>
    <p><img parentName="p" {...{
        "src": "https://distilleryimage11.instagram.com/f70b24e69e7f11e1af7612313813f8e8_7.jpg",
        "alt": "A small interview room at Google",
        "title": "A small interview room at Google"
      }}></img></p>
    <p>{`Apparently I drew the short stick and got the smallest whiteboard available as well. Maybe they knew I was short and just wanted to make me comfortable?`}</p>
    <p>{`A few moments later, my first interviewer came in. Said hello, and went right to business.`}</p>
    <h2 {...{
      "id": "the-questions"
    }}>{`The Questions`}</h2>
    <p>{`There were only three things anyone cared for:`}</p>
    <ul>
      <li parentName="ul">{`ability to solve problems you've never heard of`}</li>
      <li parentName="ul">{`Big-O and efficiency`}</li>
      <li parentName="ul"><em parentName="li">{`no`}</em>{` whiteboard coding, that means catching all `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Off-by-one_error",
          "title": "Off-by-one error"
        }}>{`off-by-one errors`}</a></li>
    </ul>
    <p>{`I especially loved the insistence on solving all problems cold. At one point I said `}<em parentName="p">{`Oh cool, I've heard of this problem before`}</em>{` and the engineer `}<strong parentName="p">{`immediately`}</strong>{` swapped it out for a new one.`}</p>
    <p>{`As a result the whole experience was much more fun - it felt like solving a series of interesting little coding puzzles that are easy enough to be solvable in full and at most optimal within ~30 minutes, but are juuuuust hard enough you actually have to rack your brain a little bit to get them.`}</p>
    <p>{`Lexical knowledge? Forget about it, whenever you don't `}<em parentName="p">{`know`}</em>{` something, they just wave you on and say it's not really important. And you can tell it doesn't matter. They don't even write it down in their notes that hey, there's this little thing you couldn't remember off the top of your head.`}</p>
    <p>{`My questions were a mix bag of designing systems and algorithms`}</p>
    <ul>
      <li parentName="ul">{`there used to be a list of questions here, but I took them out after being informed that they don't actually have hundreds of questions available to ask people`}</li>
      <li parentName="ul">{`they were essentially questions similar to those you might experience in a high school (or possibly college) programming competition`}</li>
    </ul>
    <p>{`Those were the interesting questions anyway, sprinkled between these were explanations of `}<em parentName="p">{`A Recent Interesting Thing You Did (tm)`}</em>{` - makes me giddy I gave three different answers to this question. Just to avoid talking about the same stuff all the time :)`}</p>
    <p>{`Oh and I guess there were `}<em parentName="p">{`some`}</em>{` lexical questions, like what is a singleton and how you'd get rid of it, how do closures function and how does a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Domain_Name_System",
        "title": "Domain Name System"
      }}>{`DNS lookup`}</a>{` work.`}</p>
    <h2 {...{
      "id": "how-i-did"
    }}>{`How I did?`}</h2>
    <p>{`Honestly, I have no idea how I did.`}</p>
    <p>{`Sure, I solved all the problems. With the exception of one, I even came up with the most optimal solution on my own. And I managed to catch all the off-by-one errors and corner cases and everything.`}</p>
    <p>{`But it doesn't `}<em parentName="p">{`really`}</em>{` matter how well `}<strong parentName="p">{`I`}</strong>{` did, what matters is how many others did better than me in all those little nuances like how quickly it took to solve a problem, how much you communicate and so on ... so it's really hard to say.`}</p>
    <p>{`What I `}<strong parentName="p"><em parentName="strong">{`can`}</em></strong>{` say, however, is that it was one of the most fun days I've ever had and I deeply regret the fact there were only five interviews. Everything was over with much too quickly ...`}</p>
    <p>{`But at the end of the day, I didn't even get the answer to my main question: `}<em parentName="p">{`"What's working at Google like, really?"`}</em>{` (seems like they aren't allowed to talk about this, you get canned responses when asking)`}</p>
    <p>{`So I still don't know if Google is a place I would want to work at, but my god the lunch was amazing. If they extend an offer I might accept for the food alone!`}</p>
    <p>{`PS: A coffee lab is where Googlers drink their caffeine inside the building`}</p>
    <p><img parentName="p" {...{
        "src": "https://distilleryimage2.instagram.com/23b9b7a09e8011e1a9f71231382044a1_7.jpg",
        "alt": "A Google coffee lab",
        "title": "A Google coffee lab"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.seomoz.org/blog/whiteboard-friday-interview-with-googles-maile-ohye"
        }}>{`Whiteboard Friday - Interview with Google's Maile Ohye`}</a>{` (seomoz.org)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://news.cnet.com/8301-1035_3-57434191-94/no-terminator-style-overlays-in-first-batch-of-google-glasses/?part=rss&subj=News-Mobile"
        }}>{`No Terminator-style overlays in first batch of Google Glasses`}</a>{` (news.cnet.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.seomoz.org/blog/replicate-googles-panda-questionnaire-whiteboard-friday"
        }}>{`Replicate Google's Panda Questionnaire - Whiteboard Friday`}</a>{` (seomoz.org)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=02b2f493-1a1f-44ab-befd-b24077cff27e",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      